import { NgIf } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormsModule, ReactiveFormsModule, UntypedFormGroup, Validators } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogModule as MatDialogModule,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CsvEncodingEnum, CsvSchema, DirectivesModule, LegacyDialogsService } from 'cloud-shared-lib';
import * as _ from 'lodash';
import { Subject, filter, takeUntil, tap } from 'rxjs';
import { CsvFieldSettingsDialogComponent } from './csv-field-settings-dialog/csv-field-settings-dialog.component';

export class CsvSchemaDetailDialogData {
  csvSchema: CsvSchema;
  isClient = false;
}

@Component({
  selector: 'cloud-csv-schema-detail',
  standalone: true,
  imports: [
    NgIf,
    MatFormFieldModule,
    MatInputModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    MatTooltipModule,
    DirectivesModule,
    MatButtonModule,
  ],
  templateUrl: './csv-schema-detail-dialog.component.html',
})
export class CsvSchemaDetailDialogComponent implements OnDestroy {
  csvEncodingEnum = CsvEncodingEnum;
  csvSchemaFormGroup: UntypedFormGroup;

  get disabledForm(): boolean {
    return this.data.isClient && this.data.csvSchema.byDefault;
  }

  unsubscribe$: Subject<void> = new Subject();

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: CsvSchemaDetailDialogData,
    private formBuilder: FormBuilder,
    private dialogsService: LegacyDialogsService,
    private dialogRef: MatDialogRef<CsvSchemaDetailDialogComponent>
  ) {
    this.csvSchemaFormGroup = this.formBuilder.group({
      name: [this.data.csvSchema.name, [Validators.required]],
      separator: [this.data.csvSchema.separator],
      startImportIndex: [this.data.csvSchema.startImportIndex, [Validators.required]],
      encoding: [this.data.csvSchema.encoding, Validators.required],
    });

    if (this.disabledForm) {
      this.csvSchemaFormGroup.disable();
    }
  }

  editColumnFields(): void {
    const editedFieldsOrder = _.cloneDeep(this.data.csvSchema.fieldsOrder);

    this.dialogsService
      .component(
        CsvFieldSettingsDialogComponent,
        { columnFields: editedFieldsOrder, disabledForm: this.disabledForm },
        500
      )
      .pipe(
        filter(res => !!res),
        tap(res => (this.data.csvSchema.fieldsOrder = res)),
        takeUntil(this.unsubscribe$)
      )
      .subscribe();
  }

  saveAndClose(): void {
    const csvSchema = this.csvSchemaFormGroup.getRawValue() as CsvSchema;
    csvSchema.fieldsOrder = this.data.csvSchema.fieldsOrder;
    this.dialogRef.close(csvSchema);
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
  }
}
